import React from 'react';
import CustomNewConfirm from 'components/NewDesign/CustomNewConfirm/CustomNewConfirm';
import CustomInput from 'components/common/CustomInput';
import PropTypes from 'prop-types';

const PinUpdateFormModal = ({
  isOpen,
  onClose,
  onSave,
  currentPin,
  loading = false,
}) => {
  const [formData, setFormData] = React.useState({
    currentPin: '',
    newPin: '',
    confirmPin: '',
  });
  const [errors, setErrors] = React.useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    // Add current PIN validation
    if (!formData.currentPin.trim()) {
      newErrors.currentPin = 'Current PIN is required';
    }
    if (!/^\d{4}$/.test(formData.currentPin)) {
      newErrors.currentPin = 'Current PIN must be 4 digits';
    }

    // Check if current PIN matches the stored PIN
    if (formData.currentPin !== currentPin) {
      newErrors.currentPin = 'Current PIN is incorrect';
    }

    if (!formData.newPin.trim()) {
      newErrors.newPin = 'Provide a pin';
    }
    if (!/^\d{4}$/.test(formData.newPin)) {
      newErrors.newPin = 'PIN must be 4 digits';
    }
    if (formData.newPin !== formData.confirmPin) {
      newErrors.confirmPin = 'The provided pins do not match';
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    onSave(formData);
  };

  // Reset form when modal closes
  React.useEffect(() => {
    if (!isOpen) {
      setFormData({
        currentPin: '',
        newPin: '',
        confirmPin: '',
      });
      setErrors({});
    }
  }, [isOpen]);

  return (
    <CustomNewConfirm
      isOpen={isOpen}
      onClose={onClose}
      title={'Update PIN'}
      onConfirm={handleSubmit}
      confirmButtonText={loading ? 'Updating...' : 'Confirm'}
      showValidationRules={true}
      loading={loading}
    >
      <form onSubmit={handleSubmit}>
        <CustomInput
          label="Current PIN"
          name="currentPin"
          value={formData.currentPin}
          onChange={handleChange}
          error={errors.currentPin}
          placeholder="Enter current PIN"
          disabled={loading}
        />
        <CustomInput
          label="New PIN"
          name="newPin"
          value={formData.newPin}
          onChange={handleChange}
          error={errors.newPin}
          placeholder="e.g., 1234"
          disabled={loading}
        />
        <CustomInput
          label="Confirm PIN"
          name="confirmPin"
          value={formData.confirmPin}
          onChange={handleChange}
          error={errors.confirmPin}
          placeholder="e.g., 1234"
          disabled={loading}
        />
      </form>
    </CustomNewConfirm>
  );
};

PinUpdateFormModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  currentPin: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

export default PinUpdateFormModal;
